import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SmartCarConnectService as CmsApiSmartCarConnectService,
  SmartCarService as CmsApiSmartCarService,
} from '../../../core/cms-api/services';
import {
  GuidResult,
  Result,
  SmartCarDtoPagedResponseResult,
  SmartCarUpsertDto,
} from '../../../core/cms-api/models';

@Injectable({
  providedIn: 'root',
})
export class SmartCarsService {
  private apiService = inject(CmsApiSmartCarService);
  private connectApiService = inject(CmsApiSmartCarConnectService);

  getSmartCars(
    operatorId: string,
    pageIndex: number,
    pageSize: number
  ): Observable<SmartCarDtoPagedResponseResult> {
    return this.apiService.smartCarGet({
      OperatorId: operatorId,
      PageIndex: pageIndex,
      PageSize: pageSize,
    });
  }

  createSmartCar(request: SmartCarUpsertDto): Observable<GuidResult> {
    return this.apiService.smartCarPost({ body: request });
  }

  updateSmartCar(
    smartCarId: string,
    request: SmartCarUpsertDto
  ): Observable<GuidResult> {
    return this.apiService.smartCarIdPut({ id: smartCarId, body: request });
  }

  deleteSmartCar(smartCarId: string): Observable<Result> {
    return this.apiService.smartCarIdDelete({ id: smartCarId });
  }

  /** Revokes the vehicle's Smartcar access. */
  disconnectSmartCar(smartCarId: string): Observable<Result> {
    return this.connectApiService.smartCarIdDisconnectPost({ id: smartCarId });
  }
}
